import { useSEO } from "@/hooks/useSEO";
import { SITE } from "@/data/content";

const PRIVACY = [
  ["Information we collect", `When you submit an enquiry through this website, ${SITE.name} collects the details you provide: name, company, work email, phone number, industry, fleet size, solution of interest and your message.`],
  ["How we use it", "We use this information solely to respond to your enquiry, understand your requirement and communicate with you about Wexoz solutions and services. We do not sell your information."],
  ["Storage and security", "Enquiries are stored securely and access is limited to Wexoz personnel who need it to respond to you. Enquiry notifications may be sent by email to Wexoz staff."],
  ["Your rights", "You may request access to, correction of, or deletion of your personal information at any time by contacting Wexoz through this website."],
];

const TERMS = [
  ["Use of this website", `This website is operated by ${SITE.name}, ${SITE.location}. By using it you agree to these terms.`],
  ["Content", "Content on this website describes capabilities, reference architectures and technology options. It does not constitute an offer or guarantee of specific results. Solutions are scoped and proposed individually."],
  ["Third-party platforms", "References to third-party platforms, hardware or technologies are for identification only. Such products are owned by their respective companies. Wexoz deploys and integrates them where appropriate to a customer's requirements."],
  ["Intellectual property", `Unless otherwise stated, the content, design and branding of this website are the property of ${SITE.name}.`],
];

export default function Legal({ type }) {
  const isPrivacy = type === "privacy";
  const title = isPrivacy ? "Privacy Policy" : "Terms of Use";
  useSEO({ title: `${title} | Wexoz` });
  const blocks = isPrivacy ? PRIVACY : TERMS;
  return (
    <section className="wrap section pt-40" data-testid={`legal-${type}`}>
      <div className="eyebrow">Legal</div>
      <h1 className="mt-4 text-4xl font-semibold sm:text-5xl">{title}</h1>
      <div className="mt-12 max-w-3xl space-y-10">
        {blocks.map(([h, p]) => (
          <div key={h}><h2 className="text-xl font-semibold">{h}</h2><p className="mt-3 leading-relaxed text-slate-400">{p}</p></div>
        ))}
      </div>
    </section>
  );
}
